import React, { useState } from 'react';

// Proxies image through a CORS-friendly service if the direct load fails.
// This handles mobile browsers that block mixed-content or hotlink-protected URLs.
const PROXY = 'https://images.weserv.nl/?url=';

export default function TileImage({ src, alt, className, style }) {
  const [errCount, setErrCount] = useState(0);

  if (!src) return null;

  const handleError = (e) => {
    if (errCount === 0) {
      // First failure: try weserv proxy
      setErrCount(1);
      e.target.src = `${PROXY}${encodeURIComponent(src)}`;
    } else if (errCount === 1) {
      // Second failure: try without https upgrade
      setErrCount(2);
      e.target.src = src.replace('https://', 'http://');
    }
    // After 2 failures, stop to avoid infinite loop
  };

  return (
    <img
      src={src}
      alt={alt}
      className={className}
      style={style}
      onError={handleError}
      loading="lazy"
      decoding="async"
    />
  );
}